import gsap from "gsap";
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from "pixi.js";
import { Container, DisplayObject } from "pixi.js";
import { LineWin, PlayWindow } from "../../api";
import { IChangeableInterval, IInterval, Interval } from "../../Context/Interval";
import { Color, CreateSpineResources, LogGroup, Rect, Size } from "../../MyHelpers";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { WinLineMarkersPIXIAPP } from "../WinLineMarkersPIXIAPP";
import { GenericWinLinesAnimationPIXIAPP, WinLinesAnimationParams, WinLinesTypeStyle } from "./GenericWinLinesAnimation";
import { DecodedImageResource } from "../../ResourceManager/ImageResource";

export interface WinSquareAnimationsParamsSpinePIXIAPP {
	readonly index: number,
	//readonly sprite: ISprite,
	readonly symbolSize: Size,
	readonly spinnableReels: ISpinnableReels,
	//readonly texturePIXIAPP : PIXI.Texture[]
}

export class WinSquareAnimationsElementsSpinePIXIAPP {
	//protected view: HTMLElement;
	protected symbolSize: Size;
	//protected sprite: ISprite;
	//protected sprCanvas: CanvasSprite;
	protected currentSquareIndex: number = 0;
	protected lineDuration: number = 250;
	protected index: number;

	protected newScaleX: number = 1.05;
	protected newScaleY: number = 1.10;

	//protected columCoordinate: number = 0;
	//protected rowCoordinates: number[] = [];lra

	protected rects: Rect[] = [];

	protected viewPIXIAPP: PIXI.Container = null;
	//protected animatedSprite : PIXI.AnimatedSprite = null;
	public constructor(params: WinSquareAnimationsParamsSpinePIXIAPP) {
		this.index = params.index;
		this.symbolSize = params.symbolSize;
		//this.sprite = params.sprite;
		//let scale: number = 1.25;
		//let symbolSize: Size = spinnableReels.GetSymbolSize();

		// square should match symbol size
		//this.sprCanvas = new CanvasSprite({sprite: this.sprite, canvasSize: params.spinnableReels.GetSymbolSize().Scale(this.newScale)});
		//this.sprCanvas.Scale(scale);
		//this.sprCanvas.Start(true);

		let columnCenterx = params.spinnableReels.GetSymbolRect(params.index, 0).centerx;

		for (let row = 0; row < params.spinnableReels.GetWindowSymbolSize().Height; row++) {
			let rowCenterY = params.spinnableReels.GetSymbolRect(params.index, row).centery;

			let r = new Rect(
				columnCenterx - (this.symbolSize.Width / 2),
				rowCenterY - (this.symbolSize.Height / 2),
				this.symbolSize.Width,
				this.symbolSize.Height
			).Scale(this.newScaleX, this.newScaleY);

			this.rects.push(r);
		}


		// default position before first "play"
		let defaultRect: Rect = this.rects[0];


		// this.view = document.createElement("div");
		// this.view.classList.add("SquareAnim" + this.index);
		// this.view.style.boxSizing = "border-box";
		// //this.view.appendChild(this.sprCanvas.View());
		// this.view.style.position = "absolute";
		// this.view.style.top = "0px";
		// this.view.style.left = "0px"; // always the same column
		// this.view.style.width = this.symbolSize.Scale(this.newScale).width + "px";
		// this.view.style.height = this.symbolSize.Scale(this.newScale).height + "px";
		// this.view.style.zIndex = "" + ZIndex.WinLines;

		// TweenLite.set(this.view, { x: defaultRect.x, y: defaultRect.y });



		// just debug stuff
		//this.view.style.visibility = "hidden";
		//this.view.style.border = "5px solid red";

		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.position.set(0,0);
		// this.viewPIXIAPP.width = this.symbolSize.Scale(this.newScale).width;
		// this.viewPIXIAPP.height = this.symbolSize.Scale(this.newScale).height;

		// gsap.set(this.viewPIXIAPP, { x: defaultRect.x, y: defaultRect.y });

		// this.animatedSprite = new PIXI.AnimatedSprite(params.texturePIXIAPP);
		// this.animatedSprite.animationSpeed = 0.5;
		// this.animatedSprite.width = this.symbolSize.Scale(this.newScale).width;
		// this.animatedSprite.height = this.symbolSize.Scale(this.newScale).height;
		// //this.animatedSprite.gotoAndPlay(0);		
		// this.viewPIXIAPP.visible = false;

		// this.viewPIXIAPP.addChild(this.animatedSprite);

	}

	public View(): HTMLElement {
		return null;
	}

	protected isOnLoop: boolean = false;
	public Start(symbolRow: number, firstShowing: boolean) {
		if (!this.isOnLoop) this.spine?.state?.setAnimation(0, "animation", true);
		this.isOnLoop = true;
		//here we can animate to move to new position
		let rect = this.rects[symbolRow];
		let params = { x: rect.x, y: rect.y };

		// first line show right away, next lines animate
		if (firstShowing) {
			//TweenLite.set(this.view, params);
			gsap.set(this.viewPIXIAPP, { x: rect.x, y: rect.y });
		}
		else {
			//TweenLite.to(this.view, 0.125, params);
			gsap.set(this.viewPIXIAPP, { duration: 0.125, x: rect.x, y: rect.y });
		}

		//this.view.style.visibility = "";		
		//this.animatedSprite.gotoAndPlay(0);
		this.viewPIXIAPP.visible = true;

		// restart, so sprites are in sync
		//this.sprCanvas.Restart(true);


	}

	public Stop(): void {
		//this.view.style.visibility = "hidden";
		//this.sprCanvas.Stop();

		this.spine?.state?.clearTracks();
		this.spine?.skeleton?.setBonesToSetupPose();
		this.spine?.skeleton?.setToSetupPose();
		this.spine?.skeleton?.setSlotsToSetupPose();
		this.spine?.state?.update(0);
		this.spine?.update(0);
		this.viewPIXIAPP.visible = false;
		//this.animatedSprite.stop();
		this.isOnLoop = false;

	}

	public Update() {
		//this.sprCanvas.Update();
	}

	// public ViewPIXIAPP(): PIXI.Container{
	// 	return this.viewPIXIAPP;
	// }
	protected spine: Spine = null;
	public CreatePIXIAPP(jsonSpine: ISkeletonData) {



		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.position.set(0, 0);
		this.viewPIXIAPP.width = this.symbolSize.Scale(this.newScaleX).Width;
		this.viewPIXIAPP.height = this.symbolSize.Scale(this.newScaleY).Height;
		//put default position 
		gsap.set(this.viewPIXIAPP, { x: this.rects[0].x, y: this.rects[0].y });
		this.viewPIXIAPP.visible = false;

		//create Spine 
		this.spine = CreateSpineResources(jsonSpine);
		this.spine.width = this.symbolSize.Scale(this.newScaleX).Width;
		this.spine.height = this.symbolSize.Scale(this.newScaleY).Height;
		this.spine.state.timeScale = 1;
		this.viewPIXIAPP.addChild(this.spine);


		return this.viewPIXIAPP;
	}
}

export class WinSquaresAnimationsSpinePIXIAPP extends GenericWinLinesAnimationPIXIAPP {
	public override IsRunning(): boolean {
		return false;
	}
	//protected sprite: Sprite;
	protected logGroup: LogGroup;
	protected spinnableReels: ISpinnableReels;
	protected resid: ResourceIdentifier;
	protected symbolSize: Size;
	protected viewSize: Size;
	protected slotWindow: Rect = null;
	protected slotWindowSymbolSize: PlayWindow = null;
	protected elements: WinSquareAnimationsElementsSpinePIXIAPP[] = [];
	//protected view: HTMLElement;
	protected lines: number[][];
	protected squareDuration: number = 250;

	protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/";


	protected resultLines: LineWin[];
	protected currentResultLineIndex: number = 0;
	protected nextLineInterval: IChangeableInterval = null

	protected readonly animateOnlyWinningSymbols: boolean = true;
	//Create Markers for win Lines
	protected winLineMarkers: WinLineMarkersPIXIAPP = null;
	protected running: boolean = false;

	//create view pixi app 
	protected viewPIXIAPP: PIXI.Container = null;
	protected gameName: string = "";
	//constructor(viewSize: Size, slotWindow: PixelRect, slotWindowSymbolSize:Size, spinnableReels: SpinnableReels, logGroup: LogGroup, resid: ResourceIdentifier)
	protected winLinesTypeStyle: WinLinesTypeStyle = null
	constructor(params: WinLinesAnimationParams) {
		super();
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("WinSquaresSpinePIXIAPPAnimation");
		this.resid = params.resid.Add("WinSquaresSpinePIXIAPPAnimation");
		this.slotWindow = params.spinnableReels.GetWindowRect();
		this.slotWindowSymbolSize = params.spinnableReels.GetWindowSymbolSize();

		this.symbolSize = params.spinnableReels.GetSymbolSize();

		this.lines = params.lines;

		this.nextLineInterval = new Interval(this.resid, () => this.NextLine(), 2000);
		this.winLineMarkers = new WinLineMarkersPIXIAPP(params.slotWindow, Size.FromPlayWindow(this.spinnableReels.GetWindowSymbolSize()), this.lines, params.spinnableReels.GetSymbolSize());
		this.squareDuration = params.speedFactorAnimation;
		this.gameName = params.gameName;
		this.winLinesTypeStyle = params.winLinesTypeStyle;
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + "resources/neonsquare", ResourceIdentifier.Global.Add("neonsquare").Add("neonsquare"), true, this.logGroup.Add("neonsquare"), true));

		let bonusResorucesSpine: string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/WinLines/SquareWinLines/SquareWinLines`;
		if (this.winLinesTypeStyle == WinLinesTypeStyle.gameStyle) bonusResorucesSpine = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/SquareWinLines/SquareWinLines`
		//Spine Prepare 				
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}.json`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}.atlas`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationATLAS`)));

	}

	//protected texturePIXIAPP: PIXI.Texture[] = [];
	protected jsonSpine: ISkeletonData = null
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`));
		let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
		this.jsonSpine = spineAsset.spineData;


		let numberOfColumns = this.spinnableReels.GetWindowSymbolSize().Width;
		for (let i = 0; i < numberOfColumns; i++) {
			let params: WinSquareAnimationsParamsSpinePIXIAPP = {
				index: i,
				//sprite: this.sprite.Copy(),
				symbolSize: this.spinnableReels.GetSymbolSize(),
				spinnableReels: this.spinnableReels,
			}
			// create Element
			let element = new WinSquareAnimationsElementsSpinePIXIAPP(params);

			// save element to array
			this.elements.push(element);
		}

	}


	public Start(resultLines: LineWin[], duration: number): void {

		this.running = true;

		if (resultLines?.length) {
			// Log.Debug(this.logGroup, "Start");			
			this.squareDuration = duration;
			this.resultLines = resultLines;
			this.currentResultLineIndex = 0;

			// TODO use duration for interval!
			this.nextLineInterval.ChangeInterval(this.squareDuration);
			this.nextLineInterval.Start();

			// show first line right await
			this.NextLine();
		}
	}

	public override Stop(interrupted: boolean) {
		this.running = false;
		this.nextLineInterval.Stop();
		for (let column = 0; column < this.elements.length; column++) {
			this.elements[column]?.Stop();
		}
		this.winLineMarkers.Hide();

		this.OnComplete(interrupted);
	}



	protected NextLine() {

		// check if any lines remaining
		// if not, stop the interval and hide squares

		if (this.currentResultLineIndex >= this.resultLines.length) {
			this.Stop(true);
			return;
		}

		// show current line
		let currentResultLine: LineWin = this.resultLines[this.currentResultLineIndex];
		// this holds rows for each column 0, 1, 2, 1, 0
		let currentLine: number[] = this.lines[currentResultLine.LineIndex];

		// Log.Debug(this.logGroup, "Showing line " + this.currentResultLineIndex, currentLine);

		let symbols = currentResultLine.SymbolCount;
		let column = 0

		// show only first symbols
		for (; column < symbols; column++) {
			let row = currentLine[column];

			// here we would tell to what row it should move that particular square
			this.elements[column].Start(row, this.currentResultLineIndex == 0);
		}

		// hide remaining squares
		for (; column < this.elements.length; column++) {
			this.elements[column].Stop();
		}


		if (this.currentResultLineIndex == 0) {
			this.OnStartLine(currentResultLine, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01), this.animateOnlyWinningSymbols);
			this.winLineMarkers.Show(currentResultLine.LineIndex, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01))
		}

		this.OnNextLine(currentResultLine, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01), this.animateOnlyWinningSymbols);
		this.winLineMarkers.Show(currentResultLine.LineIndex, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01))


		this.currentResultLineIndex++;

		//console.log(`Drawing line: ${this.currentResultLineIndex}/${this.resultLines.length}`);

	}

	public RequestStop(): void {
		this.Stop(true);
	}

	// TODO need to check...
	// do we even need that?
	// we have "OnComplete" callback, that signals when its complete
	public GetDuration(): number {
		return this.resultLines.length * this.squareDuration;;
	}

	public Update(): void {
		// update sprites, when running
		if (this.running) {
			for (let i = 0; i < this.elements.length; i++) {
				this.elements[i].Update();
			}
		}
	}

	public View(): HTMLElement {
		return null;
	}

	public ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public override CreatePIXIAPP(containerPIXI: PIXI.Container) {
		//create view for everything 

		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.width = this.viewSize.Width;
		this.viewPIXIAPP.height = this.viewSize.Height;
		this.viewPIXIAPP.name = "WinSquaresAnimation";
		//this.viewPIXIAPP.position.set(0, Settings.ScreenHeight * (Settings.Screens - 1));
		this.elements.forEach((element) => {
			if (containerPIXI != null) containerPIXI.addChildAt(element.CreatePIXIAPP(this.jsonSpine), 1);
			else this.viewPIXIAPP.addChild(element.CreatePIXIAPP(this.jsonSpine));
		});
		//create markes for show win line hit
		let containerWinLineMarkers = this.winLineMarkers.CreateViewAPP();
		containerWinLineMarkers.forEach((ele) => {
			this.viewPIXIAPP.addChild(ele);
		});

		//if(containerPIXI != null) containerPIXI.addChildAt(this.viewPIXIAPP,1);
	}
}

export class WinSquaresAnimationsSpinePIXIAPPLimitedLineLoop extends GenericWinLinesAnimationPIXIAPP {
	public override IsRunning(): boolean {
		return this.running;
	}
	protected logGroup: LogGroup;
	protected spinnableReels: ISpinnableReels;
	protected resid: ResourceIdentifier;
	protected symbolSize: Size;
	protected viewSize: Size;
	protected slotWindow: Rect = null;
	protected slotWindowPixi: PIXI.Rectangle = null;
	protected slotWindowSymbolSize: PlayWindow = null;
	protected elements: WinSquareAnimationsElementsSpinePIXIAPP[] = [];
	protected lines: number[][];
	protected squareDuration: number = 250;
	protected glowActive: boolean = false;
	protected glowPhase: number = 0;
	protected glowSpeed: number = 0.1;

	protected fullLinePoints: PIXI.Point[] = [];
	protected ropeProgress: number = 0;
	protected ropeSpeed: number = 0.02;
	protected ropeErasing: boolean = false;
	protected ropeEraseProgress: number = 0;
	protected ropeEraseSpeed: number = 0.02;



	protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/";

	protected resultLines: LineWin[];
	protected currentResultLineIndex: number = 0;
	// protected nextLineInterval: IChangeableInterval = null;

	protected readonly animateOnlyWinningSymbols: boolean = true;
	protected winLineMarkers: WinLineMarkersPIXIAPP = null;
	protected running: boolean = false;

	protected viewPIXIAPP: PIXI.Container = null;
	protected gameName: string = "";
	protected winLinesTypeStyle: WinLinesTypeStyle = null;

	protected totalAnimationDuration: number = 3000;

	// protected unifiedLineOverlay: PIXI.Graphics = null;
	protected unifiedLineRope: PIXI.SimpleRope = null;

	protected linePoints: { x: number, y: number }[] = [];
	protected lineProgress: number = 0; // 0 a 1
	protected lineDrawing: boolean = false;
	protected lineSpeed: number = 0.02;
	protected squareLoopEnabled: boolean = true;

	private currentResultWinLine: LineWin = null;
	// private winLineImg: DecodedImageResource = null;
	private winLineTexture: PIXI.Texture = null;
	private lineColor: string = null;


	constructor(params: WinLinesAnimationParams) {
		super();
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("WinSquaresSpinePIXIAPPAnimation");
		this.resid = params.resid.Add("WinSquaresSpinePIXIAPPAnimation");
		this.slotWindow = params.spinnableReels.GetWindowRect();
		this.slotWindowPixi = new PIXI.Rectangle(this.slotWindow.x, this.slotWindow.y, this.slotWindow.width, this.slotWindow.height);
		this.slotWindowSymbolSize = params.spinnableReels.GetWindowSymbolSize();
		this.symbolSize = params.spinnableReels.GetSymbolSize();
		this.lines = params.lines;
		this.lineColor = params.gameColor;

		// this.nextLineInterval = new Interval(this.resid, () => this.NextLine(), 2000);
		this.winLineMarkers = new WinLineMarkersPIXIAPP(
			params.slotWindow,
			Size.FromPlayWindow(this.spinnableReels.GetWindowSymbolSize()),
			this.lines,
			params.spinnableReels.GetSymbolSize()
		);

		this.squareDuration = params.speedFactorAnimation;
		this.gameName = params.gameName;
		this.winLinesTypeStyle = params.winLinesTypeStyle;
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		let bonusResorucesSpine: string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/WinLines/SquareWinLines/SquareWinLines`;
		if (this.winLinesTypeStyle == WinLinesTypeStyle.gameStyle) {
			bonusResorucesSpine = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/SquareWinLines/SquareWinLines`;
		}
		resourceManager.AddGlobal(
			new JSONResource(`${bonusResorucesSpine}.json`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`))
		);
		resourceManager.AddGlobal(
			new AtlasResource(`${bonusResorucesSpine}.atlas`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationATLAS`))
		);
		resourceManager.AddGlobal(
			new DecodedImageResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/winline/line.png`, this.resid.ScopedResourceName(["line", "image"]))
		)

	}

	protected jsonSpine: ISkeletonData = null;
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`));
		let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
		this.jsonSpine = spineAsset.spineData;

		let numberOfColumns = this.spinnableReels.GetWindowSymbolSize().Width;
		for (let i = 0; i < numberOfColumns; i++) {
			let params: WinSquareAnimationsParamsSpinePIXIAPP = {
				index: i,
				symbolSize: this.spinnableReels.GetSymbolSize(),
				spinnableReels: this.spinnableReels,
			};
			let element = new WinSquareAnimationsElementsSpinePIXIAPP(params);
			this.elements.push(element);
		}

		const winLineImg = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["line", "image"]));
		this.winLineTexture = PIXI.Texture.from(winLineImg.DecodedImage());
	}


	public Start(resultLines: LineWin[], totalDuration: number): void {
		this.running = true;
		this.resultLines = [];

		// console.log("winlines - loop", resultLines);
		if (resultLines?.length) {
			this.resultLines = resultLines;
			this.currentResultLineIndex = 0;
			this.currentResultWinLine = resultLines[0];

			this.totalAnimationDuration = totalDuration;
			this.squareDuration = totalDuration;

			this.lineDrawing = true;
			this.lineEndProgress = 0;
			this.lineStartProgress = 0;
			this.ShowSingleLine(0);
		}
	}

	public Stop(interrupted: boolean) {
		this.running = false;
		this.HideUnifiedLine();
		// this.nextLineInterval.Stop();
		for (let column = 0; column < this.elements.length; column++) {
			this.elements[column]?.Stop();
		}
		this.winLineMarkers.Hide();
	}
	public RequestStop(): void {
		this.running = false;
		this.Stop(true);

		this.resultLines = [];
		this.OnComplete(true);

	}

	public GetDuration(): number {
		return this.totalAnimationDuration;
	}



	// public Update(): void {

	// 	if (!this.running) {
	// 		return;
	// 	}

	// 	if (this.lineDrawing) {
	// 		this.lineEndProgress += this.lineSpeed;
	// 		if (this.lineEndProgress >= 1) {
	// 			this.lineEndProgress = 1;
	// 			this.lineDrawing = false;
	// 			this.lineErasing = true;
	// 			this.lineStartProgress = 0;
	// 		}
	// 		this.DrawUnifiedLineRange();
	// 	} else if (this.lineErasing) {
	// 		this.lineStartProgress += this.lineSpeed;
	// 		if (this.lineStartProgress >= 1) {
	// 			this.lineStartProgress = 1;
	// 			this.lineErasing = false;
	// 			this.HideUnifiedLine();

	// 			// Pass to the next line in loop infinite
	// 			this.currentResultLineIndex++;
	// 			if (this.currentResultLineIndex >= this.resultLines.length) {
	// 				this.currentResultLineIndex = 0; // Restart loop
	// 			}

	// 			this.ShowSingleLine(this.currentResultLineIndex);
	// 		} else {
	// 			this.DrawUnifiedLineRange();
	// 		}
	// 	}
	// }
	protected animationStartTime: number = 0;
	public Update(): void {
		if (!this.running || this.fullLinePoints.length === 0) return;

		if (!this.ropeErasing) {
			this.ropeProgress += this.ropeSpeed;

			if (this.ropeProgress >= 1) {
				this.ropeProgress = 1;
				this.ropeErasing = true;
				this.ropeEraseProgress = 0;
			} else {
				this.UpdateRopePoints();
			}
		} else {
			this.ropeEraseProgress += this.ropeEraseSpeed;

			if (this.ropeEraseProgress >= 1) {
				this.ropeEraseProgress = 1;
				this.ropeErasing = false;

				this.HideUnifiedLine();

				this.currentResultLineIndex++;
				if (this.currentResultLineIndex >= this.resultLines.length) {
					this.currentResultLineIndex = 0;
				}

				this.ShowSingleLine(this.currentResultLineIndex);
			} else {
				this.UpdateRopeErase();
			}
		}
	}

	protected UpdateRopeErase(): void {
		const total = this.fullLinePoints.length;
		const startIndex = Math.floor(this.ropeEraseProgress * total);

		if (startIndex >= total - 1) {
			this.HideUnifiedLine();
			return;
		}

		const visiblePoints = this.fullLinePoints.slice(startIndex);

		if (this.unifiedLineRope) {
			this.viewPIXIAPP.removeChild(this.unifiedLineRope);
			this.unifiedLineRope.destroy();
		}

		this.unifiedLineRope = this.CreateColoredRope(visiblePoints);
		this.viewPIXIAPP.addChild(this.unifiedLineRope);
	}


	protected CreateColoredRope(points: PIXI.Point[]): PIXI.SimpleRope {
		const texture = this.winLineTexture.clone();
		texture.updateUvs();

		const rope = new PIXI.SimpleRope(texture, points);
		rope.tint = `rgb(${this.lineColor})`;
		rope.visible = true;

		return rope;
	}

	protected ShowSingleLine(lineIndex: number): void {
		this.HideUnifiedLine();
		this.ropeProgress = 0;
		this.allLinePoints = [];
		// console.log(`Drawing line - loop: ${this.currentResultLineIndex + 1}/${this.resultLines.length}`);

		let currentResultLine: LineWin = this.resultLines[lineIndex];
		this.currentResultWinLine = currentResultLine;
		let currentLine: number[] = this.lines[currentResultLine.LineIndex];

		// IMPORTANT: Use SymbolCount to know how many symbols won really
		let winningSymbols = currentResultLine.SymbolCount;

		// Stop all elements first
		for (let column = 0; column < this.elements.length; column++) {
			this.elements[column].Stop();
		}

		// Activate ONLY the elements that won (based on SymbolCount)
		for (let column = 0; column < winningSymbols; column++) {
			let row = currentLine[column];
			this.elements[column].Start(row, true);
		}

		// Define the complete line points (to show the whole line red)
		this.PrepareUnifiedLine(currentLine, this.elements.length);
		this.OnNextLine(currentResultLine, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01), this.animateOnlyWinningSymbols);


		// Restart progress to draw
		this.lineProgress = 0;
		this.lineDrawing = true;
		this.lineEndProgress = 0;
		this.lineStartProgress = 0;
		this.ropeProgress = 0;
		this.ropeErasing = false;
		this.ropeEraseProgress = 0;

	}


	protected DrawUnifiedLineRange(): void {
		// if (!this.unifiedLineOverlay || this.allLinePoints.length === 0) return;
		if (!this.unifiedLineRope || this.allLinePoints.length === 0) return;

		// this.unifiedLineOverlay.clear();
		// this.unifiedLineOverlay.lineStyle(10, 0xFF0000, 1);

		// for (let line of this.allLinePoints) {
		// 	if (line.length < 2) continue;

		// 	let totalSegments = line.length - 1;

		// 	// Progress of line
		// 	let start = this.lineStartProgress * totalSegments;
		// 	let end = this.lineEndProgress * totalSegments;

		// 	let startIndex = Math.floor(start);
		// 	let endIndex = Math.floor(end);

		// 	let startPartial = start - startIndex;
		// 	let endPartial = end - endIndex;

		// 	// Calculate start point interpolated (between start and end)
		// 	let p0 = line[startIndex];
		// 	let p1 = line[startIndex + 1];
		// 	let startX = p0.x + (p1.x - p0.x) * startPartial;
		// 	let startY = p0.y + (p1.y - p0.y) * startPartial;

		// 	this.unifiedLineOverlay.moveTo(startX, startY);

		// 	// Draw full segments
		// 	for (let i = startIndex + 1; i <= endIndex; i++) {
		// 		this.unifiedLineOverlay.lineTo(line[i].x, line[i].y);
		// 	}

		// 	// Calculate end point interpolated
		// 	if (endIndex < totalSegments) {
		// 		let pEnd0 = line[endIndex];
		// 		let pEnd1 = line[endIndex + 1];
		// 		let endX = pEnd0.x + (pEnd1.x - pEnd0.x) * endPartial;
		// 		let endY = pEnd0.y + (pEnd1.y - pEnd0.y) * endPartial;
		// 		this.unifiedLineOverlay.lineTo(endX, endY);
		// 	}
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	protected DrawUnifiedLineErase(): void {
		// if (!this.unifiedLineOverlay || this.allLinePoints.length === 0) return;
		if (!this.unifiedLineRope || this.allLinePoints.length === 0) return;

		// this.unifiedLineOverlay.clear();
		// this.unifiedLineOverlay.lineStyle(10, 0xFF0000, 1);

		// for (let line of this.allLinePoints) {
		// 	if (line.length < 2) continue;

		// 	let totalSegments = line.length - 1;
		// 	let totalProgress = this.lineEraseProgress * totalSegments;
		// 	let fullSegments = Math.floor(totalProgress);
		// 	let partial = totalProgress - fullSegments;

		// 	this.unifiedLineOverlay.moveTo(line[0].x, line[0].y);

		// 	for (let i = 0; i < fullSegments; i++) {
		// 		this.unifiedLineOverlay.lineTo(line[i + 1].x, line[i + 1].y);
		// 	}

		// 	if (fullSegments < totalSegments) {
		// 		let p0 = line[fullSegments];
		// 		let p1 = line[fullSegments + 1];
		// 		let x = p0.x + (p1.x - p0.x) * partial;
		// 		let y = p0.y + (p1.y - p0.y) * partial;
		// 		this.unifiedLineOverlay.lineTo(x, y);
		// 	}
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	protected DrawUnifiedLineComplete(): void {
		// if (!this.unifiedLineOverlay || this.linePoints.length < 2) return;

		// this.unifiedLineOverlay.clear();
		// this.unifiedLineOverlay.lineStyle(6, 0xFF0000, 1);

		// this.unifiedLineOverlay.moveTo(this.linePoints[0].x, this.linePoints[0].y);

		// for (let i = 1; i < this.linePoints.length; i++) {
		// 	this.unifiedLineOverlay.lineTo(this.linePoints[i].x, this.linePoints[i].y);
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	public View(): HTMLElement {
		return null;
	}

	public ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public override CreatePIXIAPP(containerPIXI: PIXI.Container) {
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.width = this.viewSize.Width;
		this.viewPIXIAPP.height = this.viewSize.Height;
		this.viewPIXIAPP.name = "WinSquaresAnimation";

		this.elements.forEach((element) => {
			const created = element.CreatePIXIAPP(this.jsonSpine);
			if (containerPIXI != null) containerPIXI.addChildAt(created, 1);
			else this.viewPIXIAPP.addChild(created);
		});

		// Crear el rope con textura vacía inicialmente
		// this.unifiedLineRope = new PIXI.SimpleRope(this.winLineTexture, []);
		// this.unifiedLineRope.visible = false;
		// this.viewPIXIAPP.addChild(this.unifiedLineRope);

		let containerWinLineMarkers = this.winLineMarkers.CreateViewAPP();
		containerWinLineMarkers.forEach((ele) => {
			this.viewPIXIAPP.addChild(ele);
		});
	}



	protected allLinePoints: { x: number, y: number }[][] = [];

	protected PrepareUnifiedLine(line: number[], symbols: number): void {
		const basePoints: PIXI.Point[] = [];

		for (let col = 0; col < symbols; col++) {
			const row = line[col];
			const xCenter = this.slotWindowPixi.left + col * this.symbolSize.Width + this.symbolSize.Width / 2;
			const yCenter = this.slotWindowPixi.top + row * this.symbolSize.Height + this.symbolSize.Height / 2;
			basePoints.push(new PIXI.Point(xCenter, yCenter));
		}

		// Añadir extremos
		const firstCol = 0;
		const firstRow = line[firstCol];
		const xLeft = this.slotWindowPixi.left + firstCol * this.symbolSize.Width;
		const yLeft = this.slotWindowPixi.top + firstRow * this.symbolSize.Height + this.symbolSize.Height / 2;
		basePoints.unshift(new PIXI.Point(xLeft, yLeft));

		const lastCol = symbols - 1;
		const lastRow = line[lastCol];
		const xRight = this.slotWindowPixi.left + lastCol * this.symbolSize.Width + this.symbolSize.Width;
		const yRight = this.slotWindowPixi.top + lastRow * this.symbolSize.Height + this.symbolSize.Height / 2;
		basePoints.push(new PIXI.Point(xRight, yRight));

		// Interpolación Catmull-Rom con más densidad
		const smoothPoints: PIXI.Point[] = [];
		const resolution = 0.05; // más puntos = más suave

		for (let i = 0; i < basePoints.length - 1; i++) {
			const p0 = basePoints[i - 1] || basePoints[i];
			const p1 = basePoints[i];
			const p2 = basePoints[i + 1];
			const p3 = basePoints[i + 2] || basePoints[i + 1];

			for (let t = 0; t <= 1; t += resolution) {
				smoothPoints.push(catmullRom(p0, p1, p2, p3, t));
			}
		}

		this.fullLinePoints = smoothPoints;
		this.ropeProgress = 0;
		this.UpdateRopePoints();
	}




	protected UpdateRopePoints(): void {
		const total = this.fullLinePoints.length;
		const visibleCount = Math.floor(this.ropeProgress * total);

		if (visibleCount < 2) {
			this.HideUnifiedLine();
			return;
		}

		const visiblePoints = this.fullLinePoints.slice(0, visibleCount);

		if (this.unifiedLineRope) {
			this.viewPIXIAPP.removeChild(this.unifiedLineRope);
			this.unifiedLineRope.destroy();
		}

		this.unifiedLineRope = this.CreateColoredRope(visiblePoints);
		this.viewPIXIAPP.addChild(this.unifiedLineRope);
	}




	protected lineErasing: boolean = false;
	protected lineEraseProgress: number = 0;
	protected lineStartProgress: number = 0; // Start in line 0 (0 a 1)
	protected lineEndProgress: number = 0;   // End of line (0 a 1)


	protected DrawUnifiedLineProgressive(): void {
		// if (!this.unifiedLineOverlay || this.allLinePoints.length === 0) return;
		if (!this.unifiedLineRope || this.allLinePoints.length === 0) return;

		// this.unifiedLineOverlay.clear();
		// this.unifiedLineOverlay.lineStyle(10, 0xFF0000, 1);

		// for (let line of this.allLinePoints) {
		// 	if (line.length < 2) continue;

		// 	let totalSegments = line.length - 1;
		// 	let totalProgress = this.lineProgress * totalSegments;
		// 	let fullSegments = Math.floor(totalProgress);
		// 	let partial = totalProgress - fullSegments;

		// 	this.unifiedLineOverlay.moveTo(line[0].x, line[0].y);

		// 	for (let i = 0; i < fullSegments; i++) {
		// 		this.unifiedLineOverlay.lineTo(line[i + 1].x, line[i + 1].y);
		// 	}

		// 	if (fullSegments < totalSegments) {
		// 		let p0 = line[fullSegments];
		// 		let p1 = line[fullSegments + 1];
		// 		let x = p0.x + (p1.x - p0.x) * partial;
		// 		let y = p0.y + (p1.y - p0.y) * partial;
		// 		this.unifiedLineOverlay.lineTo(x, y);
		// 	}
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	protected HideUnifiedLine(): void {
		// if (this.unifiedLineOverlay) {
		// 	this.unifiedLineOverlay.clear();
		// 	this.unifiedLineOverlay.visible = false;
		// }
		if (this.unifiedLineRope) {
			this.unifiedLineRope.visible = false;
		}
		this.lineDrawing = false;
	}
}

export class WinSquaresAnimationsSpinePIXIAPPGridLimited extends GenericWinLinesAnimationPIXIAPP {
	public override IsRunning(): boolean {
		return this.running;
	}
	protected logGroup: LogGroup;
	protected spinnableReels: ISpinnableReels;
	protected resid: ResourceIdentifier;
	protected symbolSize: Size;
	protected viewSize: Size;
	protected slotWindow: Rect = null;
	protected slotWindowPixi: PIXI.Rectangle = null;
	protected slotWindowSymbolSize: PlayWindow = null;

	// NEW: Using grid
	protected elementsGrid: WinSquareAnimationsElementsSpinePIXIAPP[][] = [];

	protected lines: number[][];
	protected squareDuration: number = 250;
	protected glowActive: boolean = false;
	protected glowPhase: number = 0;
	protected glowSpeed: number = 0.1;

	protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/";

	protected resultLines: LineWin[];
	protected currentResultLineIndex: number = 0;

	protected readonly animateOnlyWinningSymbols: boolean = true;
	protected winLineMarkers: WinLineMarkersPIXIAPP = null;
	protected running: boolean = false;

	protected viewPIXIAPP: PIXI.Container = null;
	protected gameName: string = "";
	protected winLinesTypeStyle: WinLinesTypeStyle = null;

	protected totalAnimationDuration: number = 3000;

	// protected unifiedLineOverlay: PIXI.Graphics = null;

	protected linePoints: { x: number, y: number }[] = [];
	protected lineProgress: number = 0;
	protected lineDrawing: boolean = false;
	protected lineSpeed: number = 0.02;
	protected squareLoopEnabled: boolean = true;

	protected allLinePoints: { x: number, y: number }[][] = [];
	protected lineErasing: boolean = false;
	protected lineEraseProgress: number = 0;
	protected lineStartProgress: number = 0;
	protected lineEndProgress: number = 0;

	protected jsonSpine: ISkeletonData = null;

	protected unifiedLineRope: PIXI.SimpleRope = null;
	protected fullLinePoints: PIXI.Point[] = [];
	private winLineTexture: PIXI.Texture = null;

	protected fullLinePointsList: PIXI.Point[][] = [];
	protected unifiedLineRopes: PIXI.SimpleRope[] = [];
	private lineColor: string = null;

	protected ropeErasing: boolean = false;
	protected ropeEraseProgress: number = 0;
	protected ropeEraseSpeed: number = 0.02;

	constructor(params: WinLinesAnimationParams) {
		super();
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("WinSquaresSpinePIXIAPPAnimation");
		this.resid = params.resid.Add("WinSquaresSpinePIXIAPPAnimation");
		this.slotWindow = params.spinnableReels.GetWindowRect();
		this.slotWindowPixi = new PIXI.Rectangle(this.slotWindow.x, this.slotWindow.y, this.slotWindow.width, this.slotWindow.height);
		this.slotWindowSymbolSize = params.spinnableReels.GetWindowSymbolSize();
		this.symbolSize = params.spinnableReels.GetSymbolSize();
		this.lines = params.lines;
		this.lineColor = params?.gameColor;

		this.winLineMarkers = new WinLineMarkersPIXIAPP(
			params.slotWindow,
			Size.FromPlayWindow(this.spinnableReels.GetWindowSymbolSize()),
			this.lines,
			params.spinnableReels.GetSymbolSize()
		);

		this.squareDuration = params.speedFactorAnimation;
		this.gameName = params.gameName;
		this.winLinesTypeStyle = params.winLinesTypeStyle;
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		let bonusResorucesSpine: string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/WinLines/SquareWinLines/SquareWinLines`;
		if (this.winLinesTypeStyle == WinLinesTypeStyle.gameStyle) {
			bonusResorucesSpine = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/SquareWinLines/SquareWinLines`;
		}
		resourceManager.AddGlobal(
			new JSONResource(`${bonusResorucesSpine}.json`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`))
		);
		resourceManager.AddGlobal(
			new AtlasResource(`${bonusResorucesSpine}.atlas`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationATLAS`))
		);
		resourceManager.AddGlobal(
			new DecodedImageResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/winline/line.png`, this.resid.ScopedResourceName(["line", "image"]))
		)
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`));
		let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
		this.jsonSpine = spineAsset.spineData;

		let numberOfColumns = this.spinnableReels.GetWindowSymbolSize().Width;
		let numberOfRows = this.spinnableReels.GetWindowSymbolSize().Height;

		for (let col = 0; col < numberOfColumns; col++) {
			this.elementsGrid[col] = [];
			for (let row = 0; row < numberOfRows; row++) {
				let params: WinSquareAnimationsParamsSpinePIXIAPP = {
					index: col,
					symbolSize: this.spinnableReels.GetSymbolSize(),
					spinnableReels: this.spinnableReels,
				};
				let element = new WinSquareAnimationsElementsSpinePIXIAPP(params);
				this.elementsGrid[col][row] = element;
			}
		}

		const winLineImg = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["line", "image"]));
		this.winLineTexture = PIXI.Texture.from(winLineImg.DecodedImage());
	}

	public Start(resultLines: LineWin[], totalDuration: number): void {
		this.running = true;
		this.resultLines = [];

		if (resultLines?.length) {
			this.resultLines = resultLines;
			this.totalAnimationDuration = totalDuration;
			this.squareDuration = totalDuration;

			this.ShowAllLines();

			this.lineDrawing = true;
			this.lineEndProgress = 0;
			this.lineStartProgress = 0;
		}
	}

	protected CreateColoredRope(points: PIXI.Point[]): PIXI.SimpleRope {
		const texture = this.winLineTexture.clone();
		texture.updateUvs();

		const rope = new PIXI.SimpleRope(texture, points);
		rope.tint = `rgb(${this.lineColor})`;
		rope.visible = true;

		return rope;
	}


	protected ShowAllLines(): void {
		this.HideUnifiedLine();
		this.fullLinePointsList = [];
		this.unifiedLineRopes = [];
		this.StopAllElements();

		let winningPositions = new Set<string>();

		for (let i = 0; i < this.resultLines.length; i++) {
			let currentResultLine: LineWin = this.resultLines[i];
			let currentLine: number[] = this.lines[currentResultLine.LineIndex];
			let winningSymbols = currentResultLine.SymbolCount;

			for (let column = 0; column < winningSymbols; column++) {
				let row = currentLine[column];
				winningPositions.add(`${column},${row}`);
			}

			// Save points for each line
			this.PrepareUnifiedLine(currentLine, this.elementsGrid.length);
		}

		// Animate only winning symbols
		for (let col = 0; col < this.elementsGrid.length; col++) {
			for (let row = 0; row < this.elementsGrid[col].length; row++) {
				if (winningPositions.has(`${col},${row}`)) {
					this.elementsGrid[col][row].Start(row, true);
				} else {
					this.elementsGrid[col][row].Stop();
				}
			}
		}
	}

	protected StopAllElements(): void {
		for (let col = 0; col < this.elementsGrid.length; col++) {
			for (let row = 0; row < this.elementsGrid[col].length; row++) {
				this.elementsGrid[col][row].Stop();
			}
		}
	}
	public Stop(interrupted: boolean) {
	
		this.running = false;
		this.HideUnifiedLine();

		this.lineDrawing = false;
		this.lineErasing = false;

		this.StopAllElements();

		this.winLineMarkers.Hide();

		this.resultLines = [];
	}
	
	public RequestStop(): void {
		this.Stop(true);
		this.OnComplete(true);

	}

	public GetDuration(): number {
		return this.totalAnimationDuration;
	}

	public Update(): void {
		if (!this.running) return;

		for (let col = 0; col < this.elementsGrid.length; col++) {
			for (let row = 0; row < this.elementsGrid[col].length; row++) {
				this.elementsGrid[col][row].Update();
			}
		}

		if (this.lineDrawing) {
			this.lineEndProgress += this.lineSpeed;
			if (this.lineEndProgress >= 1) {
				this.lineEndProgress = 1;
				this.lineDrawing = false;
				this.ropeErasing = true;
				this.ropeEraseProgress = 0;
			}
			this.UpdateRopePoints();
		} else if (this.ropeErasing) {
			this.ropeEraseProgress += this.ropeEraseSpeed;
			if (this.ropeEraseProgress >= 1) {
				this.ropeEraseProgress = 1;
				this.ropeErasing = false;
				this.HideUnifiedLine();
				this.RequestStop();
			} else {
				this.UpdateRopeErase();
			}
		}

	}

	protected UpdateRopeErase(): void {
		for (let i = 0; i < this.fullLinePointsList.length; i++) {
			const points = this.fullLinePointsList[i];
			const total = points.length;
			const startIndex = Math.floor(this.ropeEraseProgress * total);

			if (startIndex >= total - 1) {
				if (this.unifiedLineRopes[i]) {
					this.viewPIXIAPP.removeChild(this.unifiedLineRopes[i]);
					this.unifiedLineRopes[i].destroy();
					this.unifiedLineRopes[i] = null;
				}
				continue;
			}

			const visiblePoints = points.slice(startIndex);

			if (!this.unifiedLineRopes[i]) {
				// Create rope if it doesn't exist
				const rope = this.CreateColoredRope(visiblePoints);
				this.viewPIXIAPP.addChild(rope);
				this.unifiedLineRopes[i] = rope;
			} else {
				// Update vertices of the existing rope
				const rope = this.unifiedLineRopes[i];
				const ropeGeom = rope.geometry as PIXI.RopeGeometry;
				ropeGeom.points = visiblePoints;
				ropeGeom.updateVertices();
			}
		}
	}






	protected DrawUnifiedLineRange(): void {
		//if (!this.unifiedLineOverlay || this.allLinePoints.length === 0) return;
		// if (!this.unifiedLineRope || this.allLinePoints.length === 0) return;

		// // this.unifiedLineOverlay.clear();
		// // this.unifiedLineOverlay.lineStyle(10, 0xFF0000, 1);

		// for (let line of this.allLinePoints) {
		// 	if (line.length < 2) continue;

		// 	let totalSegments = line.length - 1;

		// 	let start = this.lineStartProgress * totalSegments;
		// 	let end = this.lineEndProgress * totalSegments;

		// 	let startIndex = Math.floor(start);
		// 	let endIndex = Math.floor(end);

		// 	let startPartial = start - startIndex;
		// 	let endPartial = end - endIndex;

		// 	let p0 = line[startIndex];
		// 	let p1 = line[startIndex + 1];
		// 	let startX = p0.x + (p1.x - p0.x) * startPartial;
		// 	let startY = p0.y + (p1.y - p0.y) * startPartial;

		// 	this.unifiedLineOverlay.moveTo(startX, startY);

		// 	// Dibujar segmentos completos
		// 	for (let i = startIndex + 1; i <= endIndex; i++) {
		// 		this.unifiedLineOverlay.lineTo(line[i].x, line[i].y);
		// 	}

		// 	// Calcular punto final interpolado
		// 	if (endIndex < totalSegments) {
		// 		let pEnd0 = line[endIndex];
		// 		let pEnd1 = line[endIndex + 1];
		// 		let endX = pEnd0.x + (pEnd1.x - pEnd0.x) * endPartial;
		// 		let endY = pEnd0.y + (pEnd1.y - pEnd0.y) * endPartial;
		// 		this.unifiedLineOverlay.lineTo(endX, endY);
		// 	}
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	protected DrawUnifiedLineProgressive(): void {
		// if (!this.unifiedLineOverlay || this.allLinePoints.length === 0) return;

		// this.unifiedLineOverlay.clear();
		// this.unifiedLineOverlay.lineStyle(10, 0xFF0000, 1);

		// for (let line of this.allLinePoints) {
		// 	if (line.length < 2) continue;

		// 	let totalSegments = line.length - 1;
		// 	let totalProgress = this.lineProgress * totalSegments;
		// 	let fullSegments = Math.floor(totalProgress);
		// 	let partial = totalProgress - fullSegments;

		// 	this.unifiedLineOverlay.moveTo(line[0].x, line[0].y);

		// 	for (let i = 0; i < fullSegments; i++) {
		// 		this.unifiedLineOverlay.lineTo(line[i + 1].x, line[i + 1].y);
		// 	}

		// 	if (fullSegments < totalSegments) {
		// 		let p0 = line[fullSegments];
		// 		let p1 = line[fullSegments + 1];
		// 		let x = p0.x + (p1.x - p0.x) * partial;
		// 		let y = p0.y + (p1.y - p0.y) * partial;
		// 		this.unifiedLineOverlay.lineTo(x, y);
		// 	}
		// }

		// this.unifiedLineOverlay.visible = true;
	}

	public View(): HTMLElement {
		return null;
	}

	public ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public override CreatePIXIAPP(containerPIXI: PIXI.Container) {
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.width = this.viewSize.Width;
		this.viewPIXIAPP.height = this.viewSize.Height;
		this.viewPIXIAPP.name = "WinSquaresAnimationGrid";

		// Create views for all elements in the grid
		for (let col = 0; col < this.elementsGrid.length; col++) {
			for (let row = 0; row < this.elementsGrid[col].length; row++) {
				const created = this.elementsGrid[col][row].CreatePIXIAPP(this.jsonSpine);
				if (containerPIXI != null) {
					containerPIXI.addChildAt(created, 2);
				} else {
					this.viewPIXIAPP.addChild(created);
				}
			}
		}

		// this.unifiedLineOverlay = new PIXI.Graphics();
		// this.unifiedLineOverlay.visible = false;
		// this.viewPIXIAPP.addChild(this.unifiedLineOverlay);

		let containerWinLineMarkers = this.winLineMarkers.CreateViewAPP();
		containerWinLineMarkers.forEach((ele) => {
			this.viewPIXIAPP.addChild(ele);
		});

	}

	protected PrepareUnifiedLine(line: number[], symbols: number): void {
		const basePoints: PIXI.Point[] = [];

		for (let col = 0; col < symbols; col++) {
			let row = line[col];
			const xCenter = this.slotWindowPixi.left + col * this.symbolSize.Width + this.symbolSize.Width / 2;
			const yCenter = this.slotWindowPixi.top + row * this.symbolSize.Height + this.symbolSize.Height / 2;
			basePoints.push(new PIXI.Point(xCenter, yCenter));
		}

		// edges
		const firstRow = line[0];
		basePoints.unshift(new PIXI.Point(this.slotWindowPixi.left, this.slotWindowPixi.top + firstRow * this.symbolSize.Height + this.symbolSize.Height / 2));

		const lastCol = symbols - 1;
		const lastRow = line[lastCol];
		basePoints.push(new PIXI.Point(this.slotWindowPixi.left + (lastCol + 1) * this.symbolSize.Width, this.slotWindowPixi.top + lastRow * this.symbolSize.Height + this.symbolSize.Height / 2));

		// Catmull-Rom smoothing
		const smoothPoints: PIXI.Point[] = [];
		const resolution = 0.05;
		for (let i = 0; i < basePoints.length - 1; i++) {
			const p0 = basePoints[i - 1] || basePoints[i];
			const p1 = basePoints[i];
			const p2 = basePoints[i + 1];
			const p3 = basePoints[i + 2] || basePoints[i + 1];
			for (let t = 0; t <= 1; t += resolution) {
				smoothPoints.push(catmullRom(p0, p1, p2, p3, t));
			}
		}

		// Save this line in the list
		this.fullLinePointsList.push(smoothPoints);

		// Reset progress
		this.lineEndProgress = 0;
		this.lineStartProgress = 0;
	}

	protected UpdateRopePoints(): void {
		// Remove previous ropes
		for (let rope of this.unifiedLineRopes) {
			this.viewPIXIAPP.removeChild(rope);
			rope.destroy();
		}
		this.unifiedLineRopes = [];

		// Create a rope for each line
		for (let points of this.fullLinePointsList) {
			const total = points.length;
			const visibleCount = Math.floor(this.lineEndProgress * total);
			if (visibleCount < 2) continue;

			const visiblePoints = points.slice(0, visibleCount);
			const rope = this.CreateColoredRope(visiblePoints);
			this.viewPIXIAPP.addChild(rope);
			this.unifiedLineRopes.push(rope);
		}
	}

	protected HideUnifiedLine(): void {
		for (let rope of this.unifiedLineRopes) {
			if (rope) {
				this.viewPIXIAPP.removeChild(rope);
				rope.destroy();
			}
		}
		this.unifiedLineRopes = [];
		this.lineDrawing = false;
		this.ropeErasing = false;
	}
}

enum winLinesAnimationPhase {
	Init = "Init",
	ShowAllLines = "ShowAllLines",
	ShowSingleLine = "ShowSingleLine",
}
export class WinSquaresAnimationsSpinePIXIAPPGridLineLoopLimited extends GenericWinLinesAnimationPIXIAPP {

	private linesLoopAnimation: WinSquaresAnimationsSpinePIXIAPPLimitedLineLoop = null;
	private linesGridAnimation: WinSquaresAnimationsSpinePIXIAPPGridLimited = null;
	protected viewPIXIAPP: PIXI.Container = null;
	private animState: winLinesAnimationPhase = null;

	protected totalAnimationDuration: number = 3000;
	protected running: boolean = false;
	protected resultLines: LineWin[] = null;

	// private showAllLinesIntervalStart: IInterval = null;
	// private showSingleLineIntervalStart: IInterval = null;
	private gameName: string = "";

	constructor(params: WinLinesAnimationParams) {
		super();
		//this.showAllLinesIntervalStart = params.systemContext.TimingContext().CreateTimeout("ShowAllLinesInterval", 100, () => this.OnShowAllLinesBegin());
		//this.showSingleLineIntervalStart = params.systemContext.TimingContext().CreateTimeout("ShowSingleLineInterval", 100, () => this.OnShowLineByLineBegin());
		this.linesGridAnimation = new WinSquaresAnimationsSpinePIXIAPPGridLimited(params);
		this.linesLoopAnimation = new WinSquaresAnimationsSpinePIXIAPPLimitedLineLoop(params);
		this.linesLoopAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => {
			this.OnNextLine(line, null, animateOnlyWinningSymbols);
		});
		this.gameName = params.gameName;
	}

	OnInit = (): void => {
		this.animState = winLinesAnimationPhase.Init;
		this.OnShowAllLinesBegin();
	}

	public override ViewPIXIAPP(): PIXI.Container {
		return this.viewPIXIAPP;
	}

	private OnShowAllLinesBegin(): void {
		this.animState = winLinesAnimationPhase.ShowAllLines;
		this.OnStartLine(null, null, null);
		this.linesGridAnimation.Start(this.resultLines, this.totalAnimationDuration);
		// this.showSingleLineIntervalStart.Start();
	}

	private OnShowLineByLineBegin(): void {

		this.animState = winLinesAnimationPhase.ShowSingleLine;
		this.linesLoopAnimation.Start(this.resultLines, this.totalAnimationDuration);
	}

	public override CreatePIXIAPP(containerPIXI?: PIXI.Container) {
		this.linesGridAnimation.CreatePIXIAPP(containerPIXI);
		this.linesLoopAnimation.CreatePIXIAPP(containerPIXI);

		this.linesGridAnimation.AddCompleteCallbacks(() => {
			//this.OnComplete(true);
			this.linesGridAnimation.Stop(true);
			// this.animState = winLinesAnimationPhase.ShowSingleLine;
			// this.linesLoopAnimation.Start(this.resultLines, this.totalAnimationDuration);
			this.OnShowLineByLineBegin();
		});

		this.linesLoopAnimation.AddCompleteCallbacks(() => {
			// this.showSingleLineIntervalStart.Stop();
			this.OnComplete(true);

		});

		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.addChild(this.linesGridAnimation.ViewPIXIAPP(), this.linesLoopAnimation.ViewPIXIAPP());
	}

	public override Start(resultLines: LineWin[], duration: number): void {
		this.resultLines = [];
		this.requestStopCount = 0;
		//this.totalAnimationDuration = duration;
		this.running = true;

		if (resultLines?.length) {
			this.resultLines = resultLines;
			this.OnInit();
		}
	}

	public override IsRunning(): boolean {
		return this.running;
	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await this.linesGridAnimation.PrepareResources(resourceManager);
		await this.linesLoopAnimation.PrepareResources(resourceManager);
	}
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.linesGridAnimation.ResourcesLoaded(resourceManager);
		await this.linesLoopAnimation.ResourcesLoaded(resourceManager);
	}

	public override GetDuration(): number {
		//return this.totalAnimationDuration;
		return 1666;
	}
	public override Update(): void {
		if (this.animState == winLinesAnimationPhase.ShowAllLines) {
			this.linesGridAnimation.Update();

			// if(!this.linesGridAnimation.IsRunning()){
			// 	this.animState = winLinesAnimationPhase.ShowSingleLine;
			// 	this.linesLoopAnimation.Start(this.resultLines, this.totalAnimationDuration);
			// }
			return;
		}

		this.linesLoopAnimation.Update();

	}

	protected requestStopCount = 0;

	public override RequestStop(): void {

		console.log(`RequestStop() count: ${this.requestStopCount}`);
		if (this.requestStopCount == 0)
		{
			this.OnComplete(false);
		}
		else if (this.requestStopCount > 0)
		{
			this.resultLines = [];
			this.linesGridAnimation.RequestStop();
			this.linesLoopAnimation.RequestStop();
		}

		this.requestStopCount = (this.requestStopCount + 1) % 2;
		// this.running = false;
		// this.forcedStop = true;
		// this.Stop(true);

		// this.animState = winLinesAnimationPhase.NoLines;
		// this.showAllLinesIntervalStart.Stop();
		// this.showSingleLineIntervalStart.Stop();
	}




	public override Stop(interrupted: boolean): void {

		// if (this.animState == winLinesAnimationPhase.ShowAllLines) {
		// 	this.linesGridAnimation.Stop(interrupted);
		// 	return;
		// }
		// if (this.animState == winLinesAnimationPhase.ShowSingleLine) {
		// 	this.linesLoopAnimation.Stop(interrupted);
		// 	return;
		// }

		this.linesGridAnimation.Stop(interrupted);
		this.linesLoopAnimation.Stop(interrupted);

	}

	public override View(): HTMLElement {
		return null;
	}
}

function catmullRom(p0: PIXI.Point, p1: PIXI.Point, p2: PIXI.Point, p3: PIXI.Point, t: number): PIXI.Point {
	const t2 = t * t;
	const t3 = t2 * t;

	const x = 0.5 * (
		(2 * p1.x) +
		(-p0.x + p2.x) * t +
		(2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 +
		(-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3
	);

	const y = 0.5 * (
		(2 * p1.y) +
		(-p0.y + p2.y) * t +
		(2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 +
		(-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3
	);

	return new PIXI.Point(x, y);
}
